import addSeconds from 'date-fns/addSeconds';
import format from 'date-fns/format';
import type { IntlShape } from 'react-intl';

import { messages } from './messages';

export const convertVideoDuration: (
	durationInSeconds?: number | null,
	options?: {
		readable?: boolean;
		formatMessage?: IntlShape['formatMessage'];
	},
) => string | null = (
	durationInSeconds?: number | null,
	options?: { readable?: boolean; formatMessage?: IntlShape['formatMessage'] },
) => {
	if (durationInSeconds === undefined || durationInSeconds === null) {
		return null;
	}

	const ONE_HOUR = 3600;
	const ONE_MINUTE = 60;

	if (options?.readable) {
		const roundedDurationInSeconds = Math.ceil(durationInSeconds);
		const roundedHours = Math.floor(roundedDurationInSeconds / ONE_HOUR);
		const roundedMinutes = Math.floor((roundedDurationInSeconds % ONE_HOUR) / ONE_MINUTE);
		const roundedSeconds = roundedDurationInSeconds % ONE_MINUTE;

		if (options.formatMessage) {
			if (roundedDurationInSeconds < ONE_MINUTE) {
				return options.formatMessage(messages.durationInSeconds, { seconds: roundedSeconds });
			} else if (roundedDurationInSeconds < ONE_HOUR) {
				if (roundedSeconds === 0) {
					return options.formatMessage(messages.durationInMinutes, { minutes: roundedMinutes });
				}

				return options.formatMessage(messages.durationInMinutesAndSeconds, {
					minutes: roundedMinutes,
					seconds: roundedSeconds,
				});
			} else {
				return options.formatMessage(messages.durationInHours, {
					hours: roundedHours,
					minutes: roundedMinutes,
				});
			}
		}

		if (roundedDurationInSeconds < ONE_MINUTE) {
			return `${roundedSeconds} sec`;
		} else if (roundedDurationInSeconds < ONE_HOUR) {
			if (roundedSeconds === 0) {
				return `${roundedMinutes} min`;
			}

			return `${roundedMinutes} min ${roundedSeconds} sec`;
		} else {
			return `${roundedHours} hour ${roundedMinutes} min`;
		}
	}

	const date = addSeconds(new Date(0), durationInSeconds);

	if (durationInSeconds < ONE_HOUR) {
		return format(date, 'mm:ss');
	}

	return format(date, 'HH:mm:ss');
};
